<template>
  <a class="product" @click="onClick(item)" :href="item.url"
     :data-testid="`sbx-sc_autoComplete-product-${item.identifier}`">
    <img :src="item.image_url" alt="Product image" class="product__image" />
    <div class="product__data">
      <div class="product__data__label">{{ item.label }}</div>
      <div class="product__data__price">
        <span :class="['product__data__price--current', hasOriginalPrice && !hasRRpPrice ? 'highlighted' : null]">{{ formattedPrice }}</span>
        <span v-if="hasOriginalPrice" class="product__data__price--old">
          <span class="product__data__price-label"> {{ $t(originalPriceLabel) }} </span>
          <span :class="['product__data__price-discounted', hasRRpPrice ? 'price-not-highlighted' : 'price-highlighted']">
            {{ formattedOriginalPrice }}
          </span>
        </span>
      </div>
    </div>
  </a>
</template>

<script>
import { formatPrice } from '@sbx/prec-shared-utils';

export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
    currencyFormat: {
      type: Object,
      required: true,
    },
  },
  computed: {
    formattedPrice() {
      return formatPrice(Number.parseFloat(this.item.price), this.currencyFormat);
    },
    formattedOriginalPrice() {
      if (this.item.recommendedRetailPrice) {
        return formatPrice(Number.parseFloat(this.item.recommendedRetailPrice), this.currencyFormat);
      }
      if (this.item.originalPrice && this.item.originalPrice !== this.item.price) {
        return formatPrice(Number.parseFloat(this.item.originalPrice), this.currencyFormat);
      }
      return null;
    },
    hasOriginalPrice() {
      return this.formattedOriginalPrice !== null;
    },
    originalPriceLabel() {
      return this.item.recommendedRetailPrice ? 'autocomplete.discountPriceRRPLabel' : 'autocomplete.discountPriceLabel';
    },
    hasRRpPrice() {
      return this.item.recommendedRetailPrice
    },
  },
  methods: {
    onClick(item) {
      this.$emit('product-item-clicked', item);
      return true;
    },
  },
  emits: ['product-item-clicked'],
};
</script>

<style scoped lang="scss">
@import '@/scss/variables.scss';

$item-color: #333;

.product {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  margin: 0;
  padding: rem-calc(10 10 10 10);
  margin-bottom: 15px;
  border-radius: 7px;

  &,
  &:visited:not(:hover) {
    color: $item-color;
    text-decoration: none;
  }

  &__image {
    width: rem-calc(114);
    margin-right: rem-calc(12);
    border-radius: 2px;
    height: rem-calc(85);
    object-fit: cover;
  }

  &__data {
    &__label {
      font-size: rem-calc(14);
      line-height: rem-calc(21);
    }

    &__price {
      margin-top: rem-calc(7);
      font-size: rem-calc(16);
      line-height: rem-calc(24);
      font-family: $brand-font-medium;
      font-weight: 400;

      &--current {
        display: block;
        font-family: $brand-font-medium;
        font-weight: 400;
        &.highlighted {
          color: #E20421;
        }
      }
      &--old {
        display: block;
        font-family: $brand-font-regular;
        font-size: rem-calc(12);
        line-height: rem-calc(18);
        color: #595959;
        vertical-align: initial;
        white-space: nowrap;
        font-weight: 400;

        & .price-not-highlighted {
          text-decoration: none;
        }

        & .price-highlighted {
          text-decoration: line-through;
        }
      }
      &-label {
        font-size: rem-calc(12);
        line-height: rem-calc(18);
        color: #595959;
        vertical-align: initial;
        white-space: nowrap;
      }
    }
  }



  &:hover {
    color: $cta-color;
    box-shadow: rem-calc(0 1 7 0) rgb(0 0 0 / 20%);
  }
}

#{$primary-brands} {
  .product__data {
    &__label,
    &__price {
      font-weight: 600;
    }
  }
}

#{$bon-brands} {
  .product__data {
    &__label,
    &__price {
      font-family: bon-bold;
    }
  }
}

#{$secondary-brands} {
  .product__data {
    &__label,
    &__price {
      font-family: din-bold;
    }
  }
}
</style>
